<template>
  <div>
    <title>采购录入</title>
    <section class="mainDet">
        <!--S 基本信息表单-->
        <el-row class="mainWrap">
            <el-col :span="24">
                <div class="grid-content" v-if="purinfoDetail">
                    <p class="commonTit"><b>审核</b></p>
                    <div class="flexUI basicWrap">
                        <ul>
                            <li class="rulrMemo">
                                <em>销售方：</em>
                                <b>{{purinfoDetail.salername}}</b>
                            </li>
                            <li>
                                <em>供应商名称：</em>
                                <b>{{purinfoDetail.supplyername || '--'}}</b>
                            </li>
                            <li>
                                <em>采购金额：</em>
                                <b class="priceFont"><i>￥</i>{{purinfoDetail.totalamount | formatAmount}}</b>
                            </li>
                            <li class="rulrMemo">
                                <em>采购说明：</em>
                                <b>{{purinfoDetail.purinstructions?purinfoDetail.purinstructions:'--'}}</b>
                            </li>
                            <li>
                                <em>采购时间：</em>
                                <b>{{dateTime(purinfoDetail.purdate)}}</b>
                            </li>
                            <li>
                                <em>采购人：</em>
                                <b>{{purinfoDetail.puruname}}</b>
                            </li>
                        </ul>
                        <el-form :model="purchaseForm" ref="purchaseForm" label-width="100px" class="purchaseForm">
                            <ul>
                                <li>
                                    <em>状态：</em>
                                    <!-- 注意：不通过class为redColor,审核通过为blueColor -->
                                    <b class="orangeColor">待审核</b>
                                </li>
                                <li>
                                    <el-form-item label="审核：">
                                        <el-radio-group v-model="purchaseForm.status">
                                            <el-radio :label="2">审核通过</el-radio>
                                            <el-radio :label="1">审核不通过</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </li>
                                <li class="rulrMemo">
                                    <el-form-item label="审核反馈：">
                                        <el-input type="textarea" v-model="purchaseForm.memo" maxlength="50" clearable placeholder="填写审核反馈"></el-input>
                                    </el-form-item> 
                                </li>
                            </ul>
                        </el-form>
                    </div>
                </div>
            </el-col>
            
            <el-col :span="24" class="pt30">
                <div class="grid-content" id="selGoodsList">
                    <p class="commonTit"><b>采购产品</b></p>
                    <el-form :model="buyForm" ref="buyForm" class="buyForm">
                        <el-table class="comTable orderTable" ref="gsTable" :data="goodsPurdetailList" border maxHeight="650" :span-method="arraySpanMethod">
                            <el-table-column label="序号" type="index"></el-table-column>
                            <el-table-column label="供应商名称" min-width="200">
                                <template slot-scope="scope">
                                <p class="textFl pdr70" :title="scope.row.supplyername">{{scope.row.supplyername?scope.row.supplyername:'--'}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="产品名称" min-width="200">
                                <template slot-scope="scope">
                                <p class="textFl pdr70" :title="scope.row.invgoodsname">{{scope.row.invgoodsname}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="规格型号"  min-width="200">
                                <template slot-scope="scope">
                                    <p class="textFl pdr70" :title="scope.row.invkindinfo">{{scope.row.invkindinfo}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="小数点开票"  min-width="120">
                                <template slot-scope="scope">
                                    <el-switch :value="scope.row.issuppdecimal?true:false"  :width="45" class="isSwitch" :active-text="scope.row.issuppdecimal?'是':'否'" @change="switchChange(scope.row)"></el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column label="单位" min-width="100" sortable prop="unit">
                                <template slot-scope="scope">
                                    <p>{{scope.row.unit}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label=" " min-width="140">
                                <template slot-scope="scope">
                                    <p class="flexUI buyTxt regBg">
                                        <i>本次采购</i>
                                        <i :title="scope.row.unitprice">{{scope.row.unitprice}}</i>
                                        <i :title="scope.row.taxrate">{{scope.row.taxrate}}</i>
                                        <i :title="scope.row.num">{{scope.row.num}}</i>
                                    </p>
                                    <p class="flexUI buyTxt orangeBg" v-if="scope.row.infosarry&&scope.row.infosarry.length>0">
                                        <i>已有数据</i>
                                        <i :title="(scope.row.infosarry[0].title==0?scope.row.infosarry[0].unitprice:scope.row.infosarry[1].unitprice) || '--'">
                                            {{(scope.row.infosarry[0].title==0?scope.row.infosarry[0].unitprice:scope.row.infosarry[1].unitprice) || '--'}}
                                        </i>
                                        <i :title="(scope.row.infosarry[0].title==0?scope.row.infosarry[0].taxrate:scope.row.infosarry[1].taxrate) || '--'">
                                            {{(scope.row.infosarry[0].title==0?scope.row.infosarry[0].taxrate:scope.row.infosarry[1].taxrate) || '--'}}
                                        </i>
                                        <i :title="(scope.row.infosarry[0].title==0?scope.row.infosarry[0].num:scope.row.infosarry[1].num) || '--'">
                                            {{(scope.row.infosarry[0].title==0?scope.row.infosarry[0].num:scope.row.infosarry[1].num) || '--'}}
                                        </i>
                                    </p>
                                    <p class="flexUI buyTxt blueBg" v-if="scope.row.infosarry&&scope.row.infosarry.length>0">
                                        <i>汇总</i>
                                        <i :title="(scope.row.infosarry[0].title==1?scope.row.infosarry[0].unitprice:scope.row.infosarry[1].unitprice) || '--'">
                                            {{(scope.row.infosarry[0].title==1?scope.row.infosarry[0].unitprice:scope.row.infosarry[1].unitprice) || '--'}}
                                        </i>
                                        <i :title="(scope.row.infosarry[0].title==1?scope.row.infosarry[0].taxrate:scope.row.infosarry[1].taxrate) || '--'">
                                            {{(scope.row.infosarry[0].title==1?scope.row.infosarry[0].taxrate:scope.row.infosarry[1].taxrate) || '--'}}
                                        </i>
                                        <i :title="(scope.row.infosarry[0].title==1?scope.row.infosarry[0].num:scope.row.infosarry[1].num) || '--'">
                                            {{(scope.row.infosarry[0].title==1?scope.row.infosarry[0].num:scope.row.infosarry[1].num) || '--'}}
                                        </i>
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价(￥)" min-width="140" sortable prop="unitprice">
                                
                            </el-table-column>
                            <el-table-column label="税率(%)" min-width="140" sortable prop="taxrate">
                                
                            </el-table-column>
                            <el-table-column label="数量" min-width="140" sortable prop="num">
                               
                            </el-table-column>
                            <el-table-column label="单价区间(￥)"  min-width="260" fixed="right">
                                <template slot-scope="scope">
                                    <!-- 注意：汇总的单价不在这个单价区间内的话给红色框提示 -->
                                    <el-form-item class="serialInput" props="minprice" :class="{'redBorder':errorCodes.indexOf(scope.row.purdetailcode)!=-1}">
                                        <el-input v-model="scope.row.minprice" clearable @input="filterPrice" @blur="getCheckIpt(scope.row,'min')" @focus="showSelGoodsList"></el-input>
                                        <small>~</small>
                                        <el-input v-model="scope.row.maxprice" clearable @input="filterPrice" @blur="getCheckIpt(scope.row,'max')" @focus="showSelGoodsList"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <template slot="empty">
                                <div class="noData"><span>暂无数据</span></div>
                            </template>
                        </el-table>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <!--E 基本信息表单-->
        <div class="bottomBtn">
            <el-button type="primary" @click="examineSubmit">提交</el-button>
            <el-button @click="$router.back(-1)">返回列表</el-button>
        </div>
    </section>
  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import Vue from "vue";
import api from '@/apis/api.js';
export default {
    name: 'PurchaseCheck',
    data () {
        return {
            purchaseForm:{
                status:2,//审核
                memo:'',//审核反馈
            },
            payRecordList:[],
            buyForm:{//采购产品表格
                minPrice:'',//单间区间最低价
                maxPrice:'',//单间区间最高价
            },
            purcode: '', // 开票商品采购信息编号
            purinfoDetail: '', // 开票采购基础详情
            goodsPurdetailList: [], // 采购商品明细表
            errorCodes: [], // 价格区间错误编码集合
            firstTrue: true, // 防止多次点击
        }	 
    },
    filters: {

    },
    components: {
        
    },
    watch:{
        
    },
    methods: {
        // 是否支持散开改变
        switchChange(row) {
            row.issuppdecimal = row.issuppdecimal?0:1;
        },
        //滚动到可视区域
        showSelGoodsList(){
            document.getElementById('selGoodsList').scrollIntoView();
        },
        // 合并单元格
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 6 ) {
                return [1,4];
            } else if (columnIndex === 7) {
                return [0,0];
            }else if (columnIndex === 8) {
                return [0,0];
            }else if (columnIndex === 9) {
                return [0,0];
            }
        },
        // 输入的单价区间是否合法
        getCheckIpt(row,type){
            document.getElementById('selGoodsList').scrollIntoView();
            let unitprice = row.infosarry[0].title == 1?row.infosarry[0].unitprice:row.infosarry[1].unitprice;
            if(type == 'min') {
                if(row.minprice!=='') {
                    if(Number(row.minprice) > unitprice) {
                        this.$message.error({message:'单价区间最小值不能大于当前汇总单价！',offset: 200})
                    }
                } else {
                    this.$message.error({message:'单价区间最小值不能为空！',offset: 200})
                }
            } else {
                if(row.maxprice!=='') {
                    if(Number(row.maxprice) < unitprice) {
                        this.$message.error({message:'单价区间最大值不能大于当前汇总单价！',offset: 200})
                    }
                } else {
                    this.$message.error({message:'单价区间最大值不能为空！',offset: 200})
                }
            }
            if((Number(row.minprice) <= unitprice) && (unitprice <= Number(row.maxprice))) {
                if(this.errorCodes.indexOf(row.purdetailcode)!=-1) {
                    let errorIndex = this.errorCodes.indexOf(row.purdetailcode);
                    this.errorCodes.splice(errorIndex,1);
                }
            } else {
                if(this.errorCodes.indexOf(row.purdetailcode)==-1) {
                    this.errorCodes.push(row.purdetailcode);
                }
            }
        },
        // 过滤价格格式
        filterPrice(val) {
            val = this.amountChech(val);
        },
        //动态获取宽度
        getWidth() {
            if(window.innerWidth < 1600){
                document.querySelector('.basicWrap ul').style.width="50%";
                document.querySelector('.purchaseForm').style.width="50%";
            }else{
                document.querySelector('.basicWrap ul').style.width="35%";
                document.querySelector('.purchaseForm').style.width="35%";
            }
        },
        // 获取开票采购基础详情
        getInvgoodspurinfoDetail() {
            api.GET_INVGOODSPURINFODETAIL({purcode: this.purcode}).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != 'null') {
                        this.purinfoDetail = res.data.data;
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message,
                        offset: 200
                    })
                }
            })
        },
        // 获取开票采购清单信息
        getInvgoodspurdetailList() {
            let invParams = {
                purcode: this.purcode,
                pagetype: 0,
                // pageparam: {
                //     pagesize: this.pageSize, //每页条数
                //     currentpage: this.currentPage, //当前页数
                //     isnewcomp: 1 //是否需要重新统计页数
                // }
            }
            api.GET_INVGOODSPURDETAILLIST(invParams).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != 'null') {
                        this.goodsPurdetailList = [];
                        res.data.data.forEach(item => {
                            Vue.set(item,'minprice','');
                            Vue.set(item,'maxprice','');
                            this.goodsPurdetailList.push(item);
                        })
                    }
                }
            })
        },
        // 审核提交
        examineSubmit() {
            if(this.firstTrue) {
                let goodsarry = [];
                if(this.purchaseForm.status == 2) {
                    if(this.errorCodes.length>0) {
                        this.$message({
                            type: 'warning',
                            message: '请输入合法的价格区间！',
                            offset: 200
                        })
                        return false;
                    }
                    this.goodsPurdetailList.forEach(item => {
                        if(item.minprice==='' || item.maxprice==='') {
                            this.errorCodes.push(item.purdetailcode);
                        }
                        let info = {
                            purdetailcode: item.purdetailcode,
                            minprice: item.minprice,
                            maxprice: item.maxprice,
                            issuppdecimal: item.issuppdecimal,
                        }
                        goodsarry.push(info);
                    })
                    if(this.errorCodes.length>0) {
                        this.$message({
                            type: 'warning',
                            message: '请完善价格区间！',
                            offset: 200
                        })
                        return false;
                    }
                }
                let subParams = {
                    purcode: this.purcode,
                    status: this.purchaseForm.status,
                    verifymemo: this.purchaseForm.memo,
                }
                if(this.purchaseForm.status == 2) {
                    subParams.goodsarry = goodsarry;
                }
                this.firstTrue = false;
                api.REVIEWINVGOODSPURINFO(subParams).then(res => {
                    if(res.data.status == "200") {
                        this.$message({
                            type: 'success',
                            message: res.data.message,
                            offset: 200
                        })
                        this.$router.push({
                            name: '开票商品采购审核'
                        })
                    } else {
                        this.firstTrue = true;
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                            offset: 200
                        })
                    }
                }).catch(res => {
                    this.firstTrue = true;
                })
            }
        }
    },
    //============================================== 生命周期 ==============================================
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getWidth);
    },
    mounted () {
        //在dom渲染之后
        setTimeout(()=>{
            this.getWidth();   
        },200);
        if(this.$route.params.purcode) {
            this.purcode = this.$route.params.purcode;
            // 获取开票采购基础详情
            this.getInvgoodspurinfoDetail()
            // 获取开票采购清单信息
            this.getInvgoodspurdetailList()
        }
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getWidth); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.mainDet{
    position: relative;
    padding: 20px 20px 85px;
    height: calc(100% - 200px);
    overflow-y: auto;
}
.pdr70{width: auto;padding-right: 70px;}
.basicWrap ul,.purchaseForm{width:35%;}
.basicWrap ul li{margin:20px 0}
.basicWrap ul li:first-child{margin-top:10px}
.basicWrap ul li em{color:#333;width:100px;display:inline-block;text-align:right}
.basicWrap ul li b{color:#999}
.basicWrap ul li b.priceFont{color:#333}
.basicWrap ul li .black{color:#333;margin-right:5px}
.rulrMemo{display: -webkit-flex; display: flex;}
.rulrMemo b{max-width:calc(100% - 200px);max-height: 80px;overflow-y: auto;}
.mainWrap .commonTit{margin-bottom: 30px;}
.serialInput {
  width: 240px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 0;
}
.serialInput >>> .el-form-item__content{display: -webkit-flex;display: -moz-flex;display: -o-flex;display: flex;-webkit-justify-content: space-between;-moz-justify-content: space-between;-o-justify-content: space-between;justify-content: space-between;}
.serialInput >>> .el-form-item__content .el-input {
  width: 45%;
}
.serialInput >>> .el-input__inner {
  border: none;
  text-align: center;
}
.el-table--enable-row-hover .el-table__body tr:hover > td .serialInput{background: #fff!important;}
.purchaseForm ul{width: 100%!important;}
.purchaseForm>>>.el-textarea{width: 340px!important;}
.buyTxt{height: 30px;line-height: 30px;margin-bottom: 5px;position: relative;}
.buyTxt::after,.buyTxt::before{
    content:'';
    position: absolute;
    background: #fff;
    height: 30px;
    width: 20px;
    top: 0;
    -webkit-transition: background-color .25s ease;
    -moz-transition: background-color .25s ease;
    -o-transition: background-color .25s ease;
    transition: background-color .25s ease;
}
.el-table--enable-row-hover .el-table__body tr:hover > td .buyTxt::after,
.el-table--enable-row-hover .el-table__body tr:hover > td .buyTxt::before,
.el-table__body tr.hover-row>td .buyTxt::after,
.el-table__body tr.hover-row>td .buyTxt::before{
    background: #f5faf7!important;
}
.buyTxt::after{
    right: 0;
}
.buyTxt::before{
    left: 0;
}
.buyTxt i{width: calc((100% / 4) + 5px);display: inline-block;padding: 0 10px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;-o-box-sizing: border-box;box-sizing: border-box;}
.buyTxt i:first-child{padding-left: 40px;}
.regBg{background-color: rgb(255, 239, 239);color: rgb(245, 98, 98);}
.orangeBg{background-color: rgb(255, 243, 233);color: rgba(253, 131, 19, 1);}
.blueBg{background-color: rgb(234, 244, 255);color: rgb(42, 145, 249);}
.redBorder{border-color: red;}
.orderTable>>>table tr td:nth-of-type(6){border-left: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5!important;}
.orderTable>>>table tr td:nth-of-type(6) .cell{padding: 0!important;}
</style>



// WEBPACK FOOTER //
// src/views/InvoiceManage/PurchaseCheck.vue